// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/app_settings/connected_content_credentials" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsConnectedContentCredentials } from "./constants";
import type {
  AppSettingsConnectedContentCredentialsParams,
  AppSettingsConnectedContentCredentialsResult,
} from "./types";

export const getDataTableAppSettingsConnectedContentCredentials = reactQueryTableFetcherAdapter(
  appSettingsConnectedContentCredentials,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: AppSettingsConnectedContentCredentialsParams
  ): Promise<AppSettingsConnectedContentCredentialsResult> => {
    return fetch(
      "/app_settings/connected_content_credentials",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
